var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"d-flex flex-column align-start justify-center mt-12",attrs:{"cols":"12"}},_vm._l((_vm.type !== 'Combined' ? _vm.list:_vm.combined_list),function(options,index){return _c('div',{key:index,staticStyle:{"margin-bottom":"24px","width":"100%"}},[_c('SingleCityFeatures',{key:index,attrs:{"options":options}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }